import { render, staticRenderFns } from "./EscuelasAsignadas.vue?vue&type=template&id=320ca54e"
import script from "./EscuelasAsignadas.vue?vue&type=script&lang=js"
export * from "./EscuelasAsignadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports